import { FlexRowFieldListSchema, FlexRowTemplateListSchema, type FlexRowField, type FlexRowTemplate } from "@/types/FlexRows";

export const getAllFlexFields = async (): Promise<FlexRowField[]> => {
  let allFields: FlexRowField[] = [];
  await axios
    .get("/flex-rows/fields")
    .then((response) =>
      handleApiResponse(
        response,
        (data: any) => {
          allFields = FlexRowFieldListSchema.parse(data);
        },
        (errors: ApiError[]) => {
          error("An error occurred", errors[0].message);
        }
      )
    )
    .catch((e) => errorApi(e));
  return allFields;
};

export const getFlexRowTemplates = async (): Promise<FlexRowTemplate[]> => {
  let templates: FlexRowTemplate[] = [];
  await axios
    .get("/flex-rows/templates")
    .then((response) =>
      handleApiResponse(
        response,
        (data: any) => {
          templates = FlexRowTemplateListSchema.parse(data);
        },
        (errors: ApiError[]) => {
          error("An error occurred", errors[0].message);
        }
      )
    )
    .catch((e) => errorApi(e));

  return templates;
};
